module.exports = __webpack_public_path__ + "static/media/icon-mastercard-card.53bccf0e.svg";